module.exports = __webpack_public_path__ + "img/1.862d2cd.png";